import { IonContent, IonPage } from '@ionic/react';

import {
  Invalid as InvalidComponent,
  Logo,
  Padding,
  PageMeta
} from '@/components/common';

import './Invalid.css';

const Invalid: React.FC = () => {
  return (
    <IonPage id="default">
      <PageMeta title="Invalid Link - Odonto" />
      <IonContent>
        <Padding>
          <Logo />
          <InvalidComponent />
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default Invalid;
